import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-preview"
export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "button", "filename"]
  static values = {
    defaultButtonText: String
  }

  connect() {
    console.log("ImagePreview controller connected")
    // Store the default button text
    if (!this.defaultButtonTextValue && this.hasButtonTarget) {
      this.defaultButtonTextValue = this.buttonTarget.textContent.trim()
    }
  }

  // Called when a file is selected
  preview(event) {
    const file = event.target.files[0]
    
    if (!file) {
      console.log("No file selected")
      return
    }

    console.log("File selected:", file.name, file.type, file.size)

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file (JPG, GIF, or PNG)')
      this.resetPreview()
      return
    }

    // Validate file size (1MB max)
    const maxSize = 1 * 1024 * 1024 // 1MB in bytes
    if (file.size > maxSize) {
      alert('File size must be less than 1MB')
      this.resetPreview()
      return
    }

    // Read and display the image
    const reader = new FileReader()
    
    reader.onload = (e) => {
      console.log("File loaded successfully")
      this.showPreview(e.target.result, file.name)
    }
    
    reader.onerror = () => {
      console.error("Error reading file")
      alert('Error reading file. Please try again.')
      this.resetPreview()
    }
    
    reader.readAsDataURL(file)
  }

  // Show the image preview
  showPreview(imageUrl, filename) {
    // Update the preview image
    if (this.hasPreviewTarget) {
      this.previewTarget.src = imageUrl
      this.previewTarget.classList.remove('hidden')
    }

    // Hide the placeholder
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.add('hidden')
    }

    // Update button text to show success
    if (this.hasButtonTarget) {
      this.buttonTarget.innerHTML = `
        <span class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256">
            <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path>
          </svg>
          <span>Image selected</span>
        </span>
      `
      this.buttonTarget.classList.add('border-green-600', 'text-green-600')
      this.buttonTarget.classList.remove('border-stone-900', 'text-stone-900', 'hover:bg-stone-50')
    }

    // Show filename if target exists
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = filename
      this.filenameTarget.classList.remove('hidden')
    }

    console.log("Preview updated successfully")
  }

  // Reset the preview to initial state
  resetPreview() {
    // Clear the file input
    if (this.hasInputTarget) {
      this.inputTarget.value = ''
    }

    // Hide the preview image
    if (this.hasPreviewTarget) {
      this.previewTarget.src = ''
      this.previewTarget.classList.add('hidden')
    }

    // Show the placeholder
    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove('hidden')
    }

    // Reset button text
    if (this.hasButtonTarget && this.defaultButtonTextValue) {
      this.buttonTarget.textContent = this.defaultButtonTextValue
      this.buttonTarget.classList.remove('border-green-600', 'text-green-600')
      this.buttonTarget.classList.add('border-stone-900', 'text-stone-900', 'hover:bg-stone-50')
    }

    // Hide filename
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = ''
      this.filenameTarget.classList.add('hidden')
    }

    console.log("Preview reset")
  }
}

